import React from 'react'
import PropTypes from 'prop-types'

import PopupMenuButton from "src/core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import GroupMoreMenu from "./more-menu"

export default function GroupMoreButton(props) {
    return <PopupMenuButton className={Classes("group-more-icon ui5-ico-more s20 m-l-10 m-r-20", props.className)}
                            attachment="top center"
                            targetAttachment="bottom center"
                            offset="0 0"
                            menuComponent={GroupMoreMenu}
                            menuParams={{
                                isCollapsed         : props.isCollapsed,
                                onToggleCollapse    : props.onToggleCollapse
                            }}/>;
}

GroupMoreButton.propTypes = {
    isCollapsed     : PropTypes.bool,

    onToggleCollapse: PropTypes.func,
}
